module.exports = __webpack_public_path__ + "img/90.02b93677.gif";